// main.js

(function(window, document, $, undefined){
	
	
	function init(){
		
		if($(".home-tiles").length) {
			homeGallery();
		}
      
      	if($("#instagram-block").length) {
      		beginInstagramFeed();
        }
      
        //if($(".collection-block").length) {
		//	resizeBlocks();
        //}
		
		if($("#product-details").length) {
          	// set small delay for images to be loaded
          	// so the code runs properly
          	setTimeout(function(){
          		productSidebar();
				zoomGallery();
          	}, 100);
		}
		
		$("#menu-trigger").on("click", function(e){
			$("header").toggleClass("menu-on");
		});
		
	};
	
	
	function homeGallery(){
		
		$(".rslides").responsiveSlides({
			speed: 500,
			timeout: 8000,
			nav: false
		});
		
	};
  
  	
  	// Calls Instagram API
  	function beginInstagramFeed(){
   		
      var userId = '1216303429';
      var clientId = '506cc8c96ad5495bacb5ae9e8e1157f5';
      var count = '12';
      	
      $.ajax({
        
        type: 'GET',
        data: {},
        dataType: 'jsonp',
        url: 'https://api.instagram.com/v1/users/' + userId + '/media/recent/?client_id=' + clientId + '&count=' + count,
        
        success: function(x){
          buildInstagramFeed(x.data);
        },
        
        error: function(jqXHR, textStatus, error){
          console.log(jqXHR);
        }
        
      });
      	
  	};
  
  
  	// Builds ul of images from object array, from Instagram API
  	function buildInstagramFeed(dataArr){
      
      var el = document.getElementById("instagram-block"),
          ul = document.createElement("ul");
      
      for (var i = 0; i < dataArr.length; i++){
        // get reference to image object
        var o = dataArr[i];
        
        // create new list element, with thumbnail inside
        var li = document.createElement("li"),
            a = document.createElement("a"),
            img = document.createElement("img");
        a.href = o.link;
        a.target = '_blank';
        img.src = o.images.thumbnail.url;
        img.alt = "Instagram photo";
        a.appendChild(img);
        li.appendChild(a);
        ul.appendChild(li);
      }
      
      // add ul to DOM
      el.appendChild(ul);
      
    }
	
  
    function resizeBlocks(){
	
      // resize the first three products
      $(".product-item").slice(0,3).each(function(i){
      	$(this).addClass("grid-third");  
      });
      
    };
  	
	
	function zoomGallery(){
		
		var galleryContainer = $("#gallery-container"),
			galleryImg = galleryContainer.find("img");
		
		var imgList = document.getElementById("gallery-list");
		
		$("#product-imgs > img").each(function(){
			
			var thisSrc = $(this).attr("src");
			
			var thumbLi = document.createElement("li"),
			    thumbImg = document.createElement("img");
			
            thumbImg.src = thisSrc;
			thumbLi.appendChild(thumbImg);
			imgList.appendChild(thumbLi);
			
		});
		
		
		$("#product-imgs > img").on("click", function(e){
			
			$("body").addClass("scroll-no");
			
			var clickedSrc = $(this).attr("src");
			
			galleryImg.attr("src", clickedSrc);
			galleryContainer.show();
		
		});
		
		
		$("#gallery-list > li img").on("click", function(e){
		
			var thumbSrc = $(this).attr("src");
			
			galleryImg.attr("src", thumbSrc);
		
		});
		
		
		$("#close-btn").on("click", function(e){
		
			$("body").removeClass("scroll-no");
			galleryContainer.hide();
		
		});
		
	};
	
	
	function productSidebar(){
		
		var element = $('#product-intro'),
			stopPoint;
		
		// number of rows of images (gives us the height)
		var numRowsImgs = Math.ceil($("#product-imgs > img").length / 2);
		var imgHeight = $("#product-imgs > img").height();
      	
      	// fallback if image height returns 0 (because not loaded in time)
      	if (imgHeight == 0) {
        	imgHeight = 400;
        }
          
		stopPoint = 130 + ((numRowsImgs - 1) * imgHeight);
		
		console.log("num rows = " + numRowsImgs);
      	console.log("img height = " + imgHeight);
        console.log(stopPoint);
      
		$(window).scroll(function(){
			
			// only necessary if > one row of images
			if (numRowsImgs > 1) {
			
				// how far we've scrolled
				var scrolled = $(window).scrollTop();
				
				// if we're before the element
				if (scrolled >= 0 && scrolled < 130) {
					
					element.removeClass('stop fixed-top');
					element.css("top", "auto");
					
				} // if we're between the element and the stop point
				else if (scrolled >= 130 && scrolled < stopPoint) {
					
					element.removeClass('stop');
					
					element.addClass('fixed-top');
					element.css("top", 0);
					
				} // if we're after the stop point
				else if (scrolled >= stopPoint) {
					
					element.removeClass('fixed-top');
					
					element.addClass('stop');
					element.css("top", stopPoint);
					
				}
			
			}
		
		});
		
	};
	
	
	init();
  
  	// end
	// render as loaded
	document.body.classList.add("loaded");
	
	
}(window, document, jQuery));